var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    position: 'relative',
    height: '80dvh'
  })},[_c('iframe',{style:({
      display: 'block',
      border: 'none',
      width: '100%',
      height: '100%'
    }),attrs:{"src":_vm.src,"allowfullscreen":"true","sandbox":"allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22c9833d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/ticket3/agent-management/AgentSalePerformance.vue
// module id = null
// module chunks = 